import React from 'react'
import convert from 'htmr'
import DatoImage from '../../../components/DatoRichText/DatoImage'
import BalanceText from '../../../components/BalanceText'
import LinkedInIcon from '../assets/linkedin.svg?svgr-webpack'
import { AdvisoryBoard_advisoryBoard_nutritionTeam } from '../types/AdvisoryBoard'

type Props = AdvisoryBoard_advisoryBoard_nutritionTeam

export default function PersonCard({
  headshot,
  name: personName,
  degrees,
  title,
  linkedinProfileUrl: url,
  intro,
}: Props) {
  return (
    <div
      className={`
        shadow-elevated,
        overflow-hidden rounded-16
        border-1 border-Border
    `}
    >
      {headshot && <DatoImage {...headshot} width={640} height={480} lazy />}
      <div className="px-24 pt-20">
        <div className="flex">
          <div className="mr-24">
            <h3 className="type-20-demibold">
              <BalanceText>
                <span>
                  {personName}
                  {degrees && (
                    <span className="type-17-demibold">, {degrees}</span>
                  )}
                </span>
              </BalanceText>
            </h3>
            {title && <p className="py-2 text-TypeSub">{title}</p>}
          </div>
          {url && (
            <a
              className="flex-0 ml-auto h-24 w-24"
              href={url}
              rel="noreferrer"
              target="_blank"
              title={`${personName} on LinkedIn`}
            >
              <LinkedInIcon />
              <span className="sr-only">{personName}’s LinkedIn profile</span>
            </a>
          )}
        </div>
        {intro && <div className="s-text mt-16">{convert(intro)}</div>}
      </div>
    </div>
  )
}

export const PersonCardFragment = gql`
  fragment PersonCardFragment on ProfessionalProfileRecord {
    id
    headshot {
      src: url(
        imgixParams: { w: 640, h: 480, fm: jpg, fit: crop, crop: focalpoint }
      )
      width
      height
      alt
    }
    name
    degrees
    title
    linkedinProfileUrl
    intro
  }
`
